import { render, staticRenderFns } from "./CustomBootstrapRule.vue?vue&type=template&id=470a3f98&"
import script from "./CustomBootstrapRule.vue?vue&type=script&lang=js&"
export * from "./CustomBootstrapRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports